import { RuntimeMediaQuery } from '../RuntimeMediaQuery';
export const runtimeBreakpointToMediaQueryRange = {
  [RuntimeMediaQuery.COMMON]: {},
  [RuntimeMediaQuery.DESKTOP]: {
    minWidth: 1025
  },
  [RuntimeMediaQuery.TABLET]: {
    maxWidth: 1024,
    minWidth: 768
  },
  [RuntimeMediaQuery.MOBILE]: {
    maxWidth: 767
  }
};
//# sourceMappingURL=runtimeBreakpointToMediaQueryRange.js.map